{
  "FormEngineCheckboxElement": {
    "title": "Kontrollkästchen"
  },
  "mask": {
    "FormEngineCheckboxElement": {
      "groupTitle": "Kontrollkästchen",
      "inline": "In der Reihe",
      "datasource": "Optionen",
      "datasourceExpressions": "Optionsfilter",
      "nested": "Verschachtelt",
      "nestedGroupOptions": "Zugriffsschlüssel",
      "nestedGroupLabel": "Überschrift"
    }
  }
}